import React, { useState, useEffect } from 'react';
import "./textfield.css";

const TextfieldNumber = (props) => {
    const [displayValue, setDisplayValue] = useState('');

    useEffect(() => {
        const initialValue = props.defaultValue || '';
        const formatted = initialValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        setDisplayValue(formatted);
    }, [props.defaultValue]);

    const handleLocalChange = (e) => {
        const valeurBrute = e.target.value;
        const max = (props.max !== undefined && props.max !== null) 
            ? parseInt(String(props.max).replace(/\D/g, ""), 10) 
            : null;
        let valeurNettoyee = valeurBrute.replace(props.allowDecimal ? /[^\d,.]/g : /\D/g, '');

        if (max !== null && valeurNettoyee !== '') {
            if (parseInt(valeurNettoyee, 10) > max) {
                valeurNettoyee = String(max);
            }
        }
        const valeurFormatee = valeurNettoyee.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        const valeurTransmise = valeurNettoyee.replace(',', '.');
        setDisplayValue(valeurFormatee);
        if (props.index >= 0){
            props.handleChange(props.index, props.keyName, valeurTransmise);
        } else {
            props.handleChange(props.setter, valeurTransmise, props.reduxKey || null);
        }
       
    };

    return (
        <input 
            type={"text"}
            inputMode={props.allowDecimal ? "decimal" : "numeric"}
            className={"input_field"}
            placeholder={props.placeholder}
            min="0"
            max={props.max}
            value={displayValue}
            onChange={handleLocalChange}
        />
    );
};

export default TextfieldNumber;